import React from "react"
import PropTypes from "prop-types"
import IconWithTooltip from "../../../components/molecules/IconWithTooltip.molecule"
import { DateTime } from "luxon"

const SprintEstimatedBudgetEnd = ({
  estimatedEndDate,
  tooltip,
  tooltipValue = "Calculado según el consumo promedio semanal, según las últimas 8 semanas",
}) => {
  if (!estimatedEndDate) {
    return "-"
  }
  const todayDate = DateTime.now()
  if (DateTime.fromFormat(estimatedEndDate, "dd/MM/yyyy") <= todayDate) {
    tooltipValue = "Fecha en la que se finalizó el presupuesto"
  }
  return (
    <div className="flex gap-1 align-items-center">
      <div>{estimatedEndDate}</div>
      {tooltip && (
        <IconWithTooltip
          iconClassName="pi pi-info-circle text-xl"
          tooltipValue={tooltipValue}
        />
      )}
    </div>
  )
}

export default SprintEstimatedBudgetEnd

SprintEstimatedBudgetEnd.propTypes = {
  estimatedEndDate: PropTypes.string,
  tooltip: PropTypes.bool,
  tooltipValue: PropTypes.string,
}
